module.exports = __webpack_public_path__ + "static/img/drilling1.9a132b30.png";